exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ni_IO9PJahfqtprt36Nng ._2mjUc5IA0AgwcvKEUlZcJk,.ni_IO9PJahfqtprt36Nng ._1CIy_XzwXR723DUekjiplI{text-decoration:underline;text-underline-position:under}.ni_IO9PJahfqtprt36Nng ._1CIy_XzwXR723DUekjiplI{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "ni_IO9PJahfqtprt36Nng",
	"detected-link": "_2mjUc5IA0AgwcvKEUlZcJk",
	"detected-link-active": "_1CIy_XzwXR723DUekjiplI"
};